import React, { useContext } from "react";
import ContentContainer from "../ReusableComponents/ContentContainer/ContentContainer";
import HeroSection from "../ReusableComponents/HeroSection/HeroSection";
import TypingEffect from "../ReusableComponents/TypingEffect/TypingEffect";
import { Link } from "react-router-dom";
import ThemeContext from "../../contexts/ThemeContext";
import BusinessImage from "./business.png";
import styles from "./HomeBanner.module.css";
import TechStackCarousel from "../ReusableComponents/TechnologyCarousel/TechStackCarousel";
import ParticlesBackground from "../ReusableComponents/ParticlesBackground/ParticlesBackground";

const HomeBanner = () => {
  const { blackColor, whiteColor, primaryFont, secondaryFont } =
    useContext(ThemeContext);

  const primaryFontStyle = {
    fontFamily: primaryFont,
  };

  const secondaryFontStyle = {
    fontFamily: secondaryFont,
  };

  const getStartedLinkProps = {
    style: {
      ...secondaryFontStyle,
      color: blackColor,
      backgroundColor: whiteColor,
      border: "none",
    },
    to: "https://calendly.com/evolvebay/30min",
    target: "_blank",
    rel: "noopener noreferrer",
  };

  return (
    <>
      <div data-testid="HomeBanner" className={styles.HomeBanner}>
        <ParticlesBackground />
        <ContentContainer width={100} className={styles.HomeBannerWrapper}>
          <HeroSection
            contentWidthPercent={43}
            contentSection={
              <>
                <div
                  className={styles.InfoContainer}
                  style={{ color: whiteColor }}
                >
                  <h1 style={primaryFontStyle}>
                    <span className="sr-only">
                      Where imagination meets innovation
                    </span>
                    <span aria-hidden="true">
                      Where imagination <br />{" "}
                      <TypingEffect
                        text="meets innovation"
                        speed={130}
                        cursor={true}
                      />
                    </span>
                  </h1>
                  <div className={styles.ButtonContainer}>
                    <Link {...getStartedLinkProps}>Book an appointment</Link>
                  </div>
                </div>
              </>
            }
            imageSection={
              <>
                <img src={BusinessImage} alt="business" />
              </>
            }
          />
          <div className={styles.techStackCarouselWrapper}>
            <TechStackCarousel />
          </div>
        </ContentContainer>
      </div>
    </>
  );
};

export default HomeBanner;
